import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'commaSpace'
})
export class CommaSpacePipe implements PipeTransform {
  transform(value: unknown): string {
    if (Array.isArray(value)) {
      return value.join(', ');
    }
    if (typeof value === 'string') {
      return value;
    }

    return value ? value.toString() : '';
  }
}
